import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { sendNowhere } from "../../view.ts";
import { type Action } from "../../app-store.ts";
import { type Datapoint } from "../dist-bar.ts";
import { type ForceNote } from "../../../../models/note/force.ts";
import * as ForceCategory from "../../../../models/force-category.ts";
import * as Styles from "../../../styles.ts";
import { type Ulid } from "../../../../models/ulid.ts";
import { map } from "@gordonb/generator";
import { ulid } from "@std/ulid";

// Components
import "../../dui/vstack/dui-vstack.ts";
import "../force-table.ts";
import "../dist-bar.ts";
import "../../dui/hstack/dui-hstack.ts";
import "../../dui/button/dui-button.ts";

const styles = css`
  :host {
    display: block;
    height: 100cqh;
    width: 100cqw;
    container-type: size;
  }

  .fgroup {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr min-content;
    grid-template-areas:
      "main"
      "footer";
    height: 100cqh;
    grid-row-gap: var(--space-4);
  }

  .fgroup-main {
    grid-area: main;
    container-type: size;
  }

  .fgroup-footer {
    grid-area: footer;
  }
`;

@customElement("force-table-panel")
export class ForceTablePanel extends LitElement {
  static override styles = [Styles.base, styles];

  @property({ type: String })
  accessor heading: string = "Forces Table";

  @property()
  accessor forces: Map<Ulid, ForceNote> = new Map<Ulid, ForceNote>();

  @property({ type: String })
  accessor projectId: Ulid | undefined = undefined;

  @property({ attribute: false })
  accessor send = sendNowhere<Action>;

  #onCreateForce = () => {
    this.send({
      type: "set-canvas-view",
      canvasView: "force-edit",
      slug: ulid().toLowerCase(),
    });
  };

  #onActivateForceRow = (event: CustomEvent<{ slug: string }>) => {
    this.send({
      type: "set-canvas-view",
      canvasView: "force-edit",
      slug: event.detail.slug,
    });
  };

  override render() {
    const datapoints = Array.from(
      map(this.forces.values(), (force): Datapoint => {
        return {
          id: force.meta.category ?? "none",
          label: ForceCategory.toDesc(force.meta.category),
          value: 1,
          color: ForceCategory.toColor(force.meta.category),
        };
      }),
    );

    return html`
      <section class="fgroup">
        <div class="fgroup-main">
          <force-table
            fixed
            .forces="${this.forces}"
            @activate-force-row="${this.#onActivateForceRow}"
          ></force-table>
        </div>
        <footer class="fgroup-footer">
          <dui-hstack gap="6">
            <dui-button @click="${this.#onCreateForce}"
              >Create Force</dui-button
            >
            <dui-vstack class="steep-vis" gap="2">
              <dist-bar .datapoints="${datapoints}"></dist-bar>
              <div>STEEP</div>
            </dui-vstack>
          </dui-hstack>
        </footer>
      </section>
    `;
  }
}
